// src/components/PagamentoPixModal.js

import React, { useState, useEffect, useCallback } from 'react';
import { httpsCallable } from 'firebase/functions';
import { doc, onSnapshot } from 'firebase/firestore';
import { functions, db } from '../firebase';
import './PagamentoPixModal.css';

// --- INÍCIO DA ALTERAÇÃO ---
// O componente agora recebe 'dadosDevedor' como uma propriedade
const PagamentoPixModal = ({ isOpen, onClose, valor, descricaoServico, dadosDevedor, onPaymentSuccess }) => {
// --- FIM DA ALTERAÇÃO ---

    const [status, setStatus] = useState('idle');
    const [qrCodeImage, setQrCodeImage] = useState('');
    const [qrCodeCopyPaste, setQrCodeCopyPaste] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleGenerateCharge = useCallback(async () => {
        // A validação do usuário logado é feita no backend agora, mas mantemos aqui por segurança
        if (!dadosDevedor) {
            setErrorMessage("Dados do devedor não foram fornecidos.");
            setStatus('error');
            return;
        }

        setStatus('loading');
        try {
            const gerarCobrancaPix = httpsCallable(functions, 'gerarCobrancaPix');
            const result = await gerarCobrancaPix({
                valor: valor,
                descricaoServico: descricaoServico,
                dadosDevedor: dadosDevedor // <-- Usando os dados recebidos via props
            });

            const { firestoreDocId, qrCode, qrCodeImage } = result.data;
            setQrCodeImage(`data:image/png;base64,${qrCodeImage}`);
            setQrCodeCopyPaste(qrCode);
            setStatus('qrcode');

            const unsub = onSnapshot(doc(db, "cobrancas", firestoreDocId), (doc) => {
                const data = doc.data();
                if (data && data.status === 'PAGAMENTO_CONFIRMADO') {
                    unsub();
                    setStatus('success');
                    onPaymentSuccess();
                    setTimeout(() => {
                        onClose();
                        setStatus('idle');
                    }, 4000);
                }
            });

        } catch (error) {
            console.error("Erro ao gerar cobrança PIX:", error);
            setErrorMessage(error.message || "Não foi possível gerar a cobrança PIX. Tente novamente mais tarde.");
            setStatus('error');
        }
    }, [valor, descricaoServico, dadosDevedor, onClose, onPaymentSuccess]); // <-- Adicionado 'dadosDevedor' às dependências

    useEffect(() => {
        if (isOpen && status === 'idle') {
            handleGenerateCharge();
        } else if (!isOpen) {
            setStatus('idle');
        }
    }, [isOpen, status, handleGenerateCharge]);
    
    const handleCopy = () => {
        navigator.clipboard.writeText(qrCodeCopyPaste);
        alert("Código PIX copiado para a área de transferência!");
    };

    if (!isOpen) {
        return null;
    }

    // O restante do JSX permanece o mesmo
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button onClick={onClose} className="close-button">&times;</button>
                {status === 'loading' && (
                    <div className="status-container">
                        <h3>Gerando PIX...</h3>
                        <p>Aguarde, estamos contatando o Santander.</p>
                        <div className="loader"></div>
                    </div>
                )}
                {status === 'error' && (
                     <div className="status-container">
                        <h3>Ocorreu um Erro</h3>
                        <p className="error-text">{errorMessage}</p>
                        <button onClick={onClose} className="button-primary">Fechar</button>
                    </div>
                )}
                {status === 'success' && (
                    <div className="status-container">
                        <h3>Pagamento Confirmado!</h3>
                        <svg className="success-icon" viewBox="0 0 52 52">
                            <circle cx="26" cy="26" r="25" fill="none" />
                            <path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                        <p>Seu pagamento foi processado com sucesso.</p>
                    </div>
                )}
                {status === 'qrcode' && (
                    <>
                        <h3>Pague com PIX para continuar</h3>
                        <p>Abra o app do seu banco e escaneie o código abaixo:</p>
                        <div className="qr-code-container">
                            <img src={qrCodeImage} alt="QR Code PIX" />
                        </div>
                        <p className="copy-paste-label">Ou copie o código:</p>
                        <div className="copy-paste-container">
                            <input type="text" readOnly value={qrCodeCopyPaste} />
                            <button onClick={handleCopy}>Copiar</button>
                        </div>
                        <p className="waiting-text">Aguardando confirmação do pagamento...</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default PagamentoPixModal;